import React from 'react';

import {
  getDoctorChatTicketLabel,
  scssVariables,
  userFullName,
  withRouter,
  rgba,
  lang
} from 'src/helpers';
import { Avatar, MCButton, MCText, PopoverMenu, View } from 'src/components/basic';
import { ActivityLabel } from 'src/components/user/LastActivity';
import { remCss, remFontCss } from '../utils';
import BaseMessage, { tabs as messageTabs, list } from 'src/components/messages';
import messagesModel from 'src/components/messages/model';
import chatModel from 'src/components/messages/chat/model';
import analysesModel from 'src/components/messages/analysesModel';
import treatmentsModel from 'src/components/messages/treatmentsModel';
import timelineModel from 'src/components/messages/timelineModel';
import callModel from 'src/components/call/model';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import Call from 'src/components/call';
import Chat from 'src/components/messages/chat';
import AnalysesList from 'src/components/analyse/list';
import TreatmentsList from 'src/components/treatments/list';
import TimelineList from 'src/components/timeline/list';
import LANG_CONST from 'src/helpers/lang/const';
import constants from '../../../../constants';

class Message extends BaseMessage {
  componentDidMount() {
    super.componentDidMount();
    const { contact = {} } = this.props;
    messagesModel.emit('openContact', { contact: { ...contact, partnerId: contact.id } });
    messagesModel.on('auth', this.refreshAll);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    messagesModel.cancel('auth', this.refreshAll);
  }

  refreshAll = () => {
    const { contact } = chatModel.state;
    chatModel.setStateSilent({ contact: null });
    chatModel.onOpenContact({ contact });
    analysesModel.refresh();
    treatmentsModel.refresh();
    timelineModel.refresh();
  };
  openRouteContact = () => {};

  renderHeader() {
    const { contact = {} } = this.props;
    const { contactUser = {} } = messagesModel.state;
    const callUUID = callModel.state.current;
    const { isCaller, callerId } = callModel.getListState(callUUID);
    const isCalling = callUUID && (isCaller || callerId === contactUser?.id);
    return (
      <View style={{ paddingHorizontal: remCss(20) }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCss(10),
            paddingLeft: remCss(15),
            paddingBottom: remCss(25),
            backgroundColor: 'white'
          }}
        >
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              gap: remCss(10),
              alignItems: 'center'
            }}
          >
            <Avatar text={contact.firstName} width={130} height={130} image={contact.avatar} />
            <View style={{ flex: 1, gap: remCss(10) }}>
              <View style={{ flex: 1, gap: remCss(10) }}>
                <MCText
                  label={
                    userFullName(contact, true) +
                    (contact.doctorType
                      ? ' / ' + lang.t(LANG_CONST.constants.doctor_types[contact.doctorType])
                      : '')
                  }
                  numberOfLines={1}
                  size={20}
                  remFontCss={remFontCss}
                  weight={500}
                  flex
                />
                <MCText
                  label={
                    getDoctorChatTicketLabel(
                      contact.charge?.chatTicket,
                      contact.currency || constants.general.defaultCurrency
                    ) || ''
                  }
                  size={18}
                  remFontCss={remFontCss}
                  weight={500}
                  numberOfLines={1}
                />

                <MCText
                  data-testid={'public-message-contact-status'}
                  size={16}
                  remFontCss={remFontCss}
                  numberOfLines={1}
                  weight={500}
                  primary
                >
                  <ActivityLabel
                    accountState={contact?.accountState}
                    lastActivity={contact?.lastActivity}
                    connections={contact?.connections}
                  />
                </MCText>
              </View>
            </View>
          </View>
          {this.props.endConversation && (
            <MCButton
              label={LANG_CONST.buttons.end_conversation}
              quaternary
              light
              radius
              onClick={this.props.endConversation}
            />
          )}
          <MCButton
            iconname={BASE_ICONS.SEARCH}
            small
            fill={scssVariables['colors-mc-heading']}
            onClick={this.toggleSearch}
          />
          {!isCalling && (
            <MCButton
              iconname={BASE_ICONS.PHONE}
              small
              fill={scssVariables['colors-mc-heading']}
              onClick={this.startCall}
            />
          )}

          <PopoverMenu
            style={{ cursor: 'pointer' }}
            placement={'bottom-end'}
            arrowOffset={-90}
            menu={(close) => (
              <ul
                className={'mc-select-field-items'}
                style={{
                  backgroundColor: 'white',
                  padding: remCss(10)
                }}
              >
                {list
                  .filter((item) => item.isShow(contactUser, messagesModel.state.user))
                  .map((item) => (
                    <li
                      key={item.label}
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick(contactUser);
                        } else {
                          this.setOption(item);
                        }
                        close();
                      }}
                    >
                      <div className={'mc-p15 mc-pointer'}>
                        <div className={'mc-value-520'}>{item.label}</div>
                      </div>
                    </li>
                  ))}
              </ul>
            )}
          >
            {() => (
              <MCButton
                iconname={BASE_ICONS.DOTS}
                small
                fill={scssVariables['colors-mc-heading']}
              />
            )}
          </PopoverMenu>

          {this.props.onBack && (
            <View style={{ position: 'relative', height: '100%', marginLeft: remCss(-10) }}>
              <View style={{ position: 'absolute', top: 0, right: remCss(10) }}>
                <MCButton onClick={this.props.onBack} hover primary transparent>
                  <SVGIcon
                    iconname={BASE_ICONS.BACK_ARROW}
                    fill={scssVariables['colors-mc-primary']}
                    width={30}
                  />
                  <span className={'mc-text-518'}>{lang.t(LANG_CONST.buttons.back)}</span>
                </MCButton>
              </View>
            </View>
          )}
        </View>
        {isCalling && <Call />}
        {messagesModel.state.enableSearch ? (
          <View style={{ padding: remCss(10) }}>{this.renderSearchMessage()}</View>
        ) : !isCalling && contactUser ? (
          <View
            style={{
              flexDirection: 'row',
              backgroundColor: rgba(scssVariables['colors-mc-primary'], 0.1),
              justifyContent: 'space-between'
            }}
          >
            {messageTabs.map((m) => {
              const active = m.id === messagesModel.getTab('main_message');
              return (
                <MCButton
                  style={{
                    paddingVertical: remCss(10),
                    transition: 'all 0.2s ease',
                    borderTop: `${remCss(2)}px solid transparent`,
                    ...(active
                      ? {
                          borderTop: `${remCss(2)}px solid ${scssVariables['colors-mc-primary']}`
                        }
                      : {})
                  }}
                  label={m.name}
                  key={m.id}
                  flex
                  medium
                  transparent={!active}
                  primary={active}
                  tertiary={!active}
                  onClick={() => messagesModel.changeMessageTab(m)}
                />
              );
            })}
          </View>
        ) : (
          <div className={'mc-line'} />
        )}
      </View>
    );
  }

  render() {
    const tab = messagesModel.getTab('main_message');
    return (
      <View
        style={{
          height: '100%',
          backgroundColor: 'white',
          flex: 1
        }}
      >
        {this.renderHeader()}
        <View style={{ display: tab === 'chat' ? 'flex' : 'none', flex: 1, position: 'relative' }}>
          <Chat treatmentsModel={treatmentsModel} />
        </View>
        <View style={{ display: tab === 'analyses' ? 'flex' : 'none', flex: 1 }}>
          <AnalysesList model={analysesModel} />
        </View>
        <View style={{ display: tab === 'treatment' ? 'flex' : 'none', flex: 1 }}>
          <TreatmentsList model={treatmentsModel} showDoctor={true} />
        </View>
        <View style={{ display: tab === 'timeline' ? 'flex' : 'none', flex: 1 }}>
          <TimelineList
            selectJourney={timelineModel.selectJourney}
            journeys={
              timelineModel.listInput('journeys', timelineModel.state.partnerId + ':recent') || []
            }
            journey={timelineModel.listInput('journey', timelineModel.state.partnerId + ':recent')}
            journeyId={timelineModel.listInput(
              'journeyId',
              timelineModel.state.partnerId + ':recent'
            )}
            model={timelineModel}
          />
        </View>
      </View>
    );
  }
}

export default withRouter(Message);
